import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from './pages/Login';
import { HealthPage } from './pages/Health';
import { DashboardPage } from './pages/Dashboard';
import { CaixaPage } from './pages/Caixa';
import { ContasPagarPage } from './pages/ContasPagar';
import { ContasReceberPage } from './pages/ContasReceber';
import { RecorrentesPage } from './pages/Recorrentes';
import { PlanoContasPage } from './pages/PlanoContas';
import { ContrapartesPage } from './pages/Contrapartes';
import { ContasPage } from './pages/Contas';
import { CentrosCustoPage } from './pages/CentrosCusto';
import { TransferenciasPage } from './pages/Transferencias';
import { RelatoriosPage } from './pages/Relatorios';
import { UsersPage } from './pages/Users';
import { SegurancaPage } from './pages/Seguranca';
import { AuditLogsPage } from './pages/AuditLogs';
import { ManutencaoPage } from './pages/Manutencao';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppLayout } from './components/layout/AppLayout';

export function App() {
  return (
    <Routes>
      {/* Públicas */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/health" element={<HealthPage />} />

      {/* Autenticadas */}
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/caixa" element={<CaixaPage />} />
        <Route path="/contas-pagar" element={<ContasPagarPage />} />
        <Route path="/contas-receber" element={<ContasReceberPage />} />
        <Route path="/recorrentes" element={<RecorrentesPage />} />

        {/* Cadastros */}
        <Route path="/cadastros" element={<Navigate to="/cadastros/contrapartes" replace />} />
        <Route path="/cadastros/contrapartes" element={<ContrapartesPage />} />
        <Route path="/cadastros/plano-contas" element={<PlanoContasPage />} />
        <Route path="/cadastros/contas" element={<ContasPage />} />
        <Route path="/cadastros/centros-custo" element={<CentrosCustoPage />} />
        <Route path="/cadastros/transferencias" element={<TransferenciasPage />} />

        {/* Aliases das URLs antigas (compatibilidade com links salvos) */}
        <Route path="/contrapartes" element={<Navigate to="/cadastros/contrapartes" replace />} />
        <Route path="/plano-contas" element={<Navigate to="/cadastros/plano-contas" replace />} />

        <Route path="/relatorios" element={<RelatoriosPage />} />

        {/* Segurança da própria conta (qualquer usuário autenticado) */}
        <Route path="/configuracoes/seguranca" element={<SegurancaPage />} />

        {/* Configurações (admin) */}
        <Route
          path="/configuracoes"
          element={<ProtectedRoute roles={['ADMIN']}><Navigate to="/configuracoes/usuarios" replace /></ProtectedRoute>}
        />
        <Route
          path="/configuracoes/usuarios"
          element={<ProtectedRoute roles={['ADMIN']}><UsersPage /></ProtectedRoute>}
        />
        <Route
          path="/configuracoes/audit"
          element={<ProtectedRoute roles={['ADMIN']}><AuditLogsPage /></ProtectedRoute>}
        />
        <Route
          path="/configuracoes/manutencao"
          element={<ProtectedRoute roles={['ADMIN']}><ManutencaoPage /></ProtectedRoute>}
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
